import React from 'react';
import { Link } from 'react-router-dom';

/**
 * @author: Alisa Münsterberg
 * @date: 2022-10-14
 */

export class ExplainButton extends React.Component{
    render(){
        return(
          <Link to="/explanation" style={{textDecoration : 'none'}}>
            <button className="App-button">
              Was ist Bubblesort?
            </button>
          </Link>
        )};
}